export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
}

export class GetChequeRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}

export class Filter {
  isDigital: boolean | undefined;
  chequeType: string | undefined;
  amountFrom: number | undefined;
  amountTo: number | undefined;
  dueDateFrom: Date | undefined;
  dueDateTo: Date | undefined;
  bankCodes: string[] | undefined;
  sayadNumber: string | undefined;
  ibanNumber: string | undefined;
  seriesNo: string | undefined;
  serialNo: string | undefined;
}

export class GetChequeResponse {
  isDigital: boolean | undefined;
  isDigitalTitle: string | undefined;
  chequeType: string | undefined;
  chequeTypeTitle: string | undefined;
  amount: string | undefined;
  dueDate: Date | undefined;
  dueDate_Persian: string | undefined;
  bankTitle: string | undefined;
  sayadNumber: string | undefined;
  ibanNumber: string | undefined;
  seriesNo: string | undefined;
  serialNo: string | undefined;
  signer: string | undefined;
  excpectedHolderName: string | undefined;
  referenceKey: string | undefined;
}
